import { FloorplanData } from '../types/FloorplanData';
import { post, put } from './baseAxios';
import { axios } from './baseAxios';
import { API_TOURS } from '../utils/urls';

type CreateFloorplanRequest = {
  tour: { id: number };
  floorplan: FloorplanData;
};

type CreateFloorplansRequest = {
  tour: { id: number, lastModifiedDate: Date | string };
  floorplans: FloorplanData;
};

const url = API_TOURS;
export const updateFloorplans = (request: CreateFloorplansRequest) =>
  post(`${url}/floorplans`, request);

export const createFloorplan = (request: CreateFloorplanRequest) =>
  post(`${url}/floorplan`, request);

export const deleteFloorplan = (tourId: number, floorPlanId: number) =>
  axios.delete(`${url}/${tourId}/floorplan/${floorPlanId}`);

export const updateEnabledRadar = (tourId: number, floorPlanId: number, enabled: boolean) =>
  put(`${url}/${tourId}/floorplan/${floorPlanId}/radar`, `${enabled}`);